import { render, staticRenderFns } from "./RegisterMember.vue?vue&type=template&id=54c9661b&scoped=true&"
import script from "./RegisterMember.vue?vue&type=script&lang=js&"
export * from "./RegisterMember.vue?vue&type=script&lang=js&"
import style0 from "./RegisterMember.vue?vue&type=style&index=0&id=54c9661b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c9661b",
  null
  
)

export default component.exports